import type { FinancialSortDirection } from "../types/financialUi"

export const normalizeFinancialSearch = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLocaleLowerCase("pt-BR")

export const sortFinancialRows = <T,>(
  rows: readonly T[],
  getValue: (row: T) => string | number,
  direction: FinancialSortDirection,
): T[] => {
  const multiplier = direction === "ascending" ? 1 : -1

  return rows
    .map((row, index) => ({ row, index }))
    .sort((first, second) => {
      const firstValue = getValue(first.row)
      const secondValue = getValue(second.row)
      const comparison =
        typeof firstValue === "number" && typeof secondValue === "number"
          ? firstValue - secondValue
          : String(firstValue).localeCompare(String(secondValue), "pt-BR", { numeric: true, sensitivity: "base" })

      return comparison === 0 ? first.index - second.index : comparison * multiplier
    })
    .map(({ row }) => row)
}

export const paginateFinancialRows = <T,>(rows: readonly T[], requestedPage: number, pageSize: number) => {
  const safePageSize = Math.max(1, pageSize)
  const totalPages = Math.max(1, Math.ceil(rows.length / safePageSize))
  const page = Math.min(Math.max(1, requestedPage), totalPages)
  const firstIndex = (page - 1) * safePageSize

  return {
    rows: rows.slice(firstIndex, firstIndex + safePageSize),
    page,
    totalPages,
    firstIndex,
    lastIndex: Math.min(firstIndex + safePageSize, rows.length),
  }
}
